export const urlUtils = {
  encode: (params: Record<string, string>) => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      searchParams.append(key, encodeURIComponent(value))
    })
    return searchParams.toString()
  },

  decode: (params: URLSearchParams) => {
    const decodedParams: Record<string, string> = {}
    params.forEach((value, key) => {
      decodedParams[key] = decodeURIComponent(value)
    })
    return decodedParams
  },
}
